import { render, staticRenderFns } from "./InformacoesComplementares.vue?vue&type=template&id=33812828&scoped=true&"
import script from "./InformacoesComplementares.vue?vue&type=script&lang=js&"
export * from "./InformacoesComplementares.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesComplementares.vue?vue&type=style&index=0&id=33812828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33812828",
  null
  
)

export default component.exports